<div class="root">
  <a i18n class="visually-hidden-focusable skip-to-content-sub-menu" href="#admin-moderation-content" (click)="$event.preventDefault(); adminContent.focus()">Skip the sub menu</a>

  <div class="margin-content">
    <my-horizontal-menu i18n-h1 h1="Moderation" h1Icon="moderation" [menuEntries]="menuEntries"></my-horizontal-menu>
  </div>

  <div #adminContent tabindex="-1" id="admin-moderation-content" class="margin-content outline-0">
    <router-outlet></router-outlet>
  </div>
</div>
